<template>
  <div class="cause-filter-container relative">
    <ul class="cause-filter flex flex-nowrap pl-8">
      <li>
        <button
          v-ripple
          class="cause-filter__btn"
          :class="{
            'cause-filter__active': !categoryActive
          }"
          type="button"
          @click="doFilter()"
        >
          {{ $t("ALL") }}
        </button>
      </li>
      <li v-for="category in categories" :key="category.id">
        <button
          v-ripple
          class="cause-filter__btn"
          :class="{
            'cause-filter__active': categoryActive === category.id
          }"
          type="button"
          @click="doFilter(category.id)"
        >
          {{ categoryName(category.name) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TagFilter",

  props: ["filterCauses", "postType"],

  data: function() {
    return {
      categoryActive: null
    };
  },

  computed: {
    categories () {
      return this.postType === 'cause' ? this.$getState('nposCategories')  : this.$getState('retailersCategories')
    }
  },

  methods: {
    categoryName: function(jsonStr) {
      let name = "";
      let json = "";
      try {
        json = JSON.parse(jsonStr);
      } catch (e) {
        console.log(e);
      }
      if (!json) return name;

      name =
        json[this.locale] !== undefined
          ? json[this.locale]
          : json["en"] !== undefined
          ? json["en"]
          : "";

      return name;
    },
    doFilter: function(id) {
      this.categoryActive = id;
      this.filterCauses(id);
    }
  }
};
</script>
